
import { configureStore } from '@reduxjs/toolkit';
import { leaveReducer, feedReducer, searchReasultReducer, showMessageMember, sidebarPostReducer, showNotificationCount, showRecentProjects } from './DataTransferToAnother';

const store = configureStore({
  reducer: {
    leave: leaveReducer,
    feedData: feedReducer,
    searchResult: searchReasultReducer,
    messageResult: showMessageMember,
    createPostData:sidebarPostReducer,
    notificationCounts:showNotificationCount,
    recentProjects:showRecentProjects,

  },
});

export default store;

